module.exports = __webpack_public_path__ + "img/top.b0cef9bf.png";